import { post, put, get, destroy } from '@rails/request.js';
import axios, {Axios} from 'axios';

export class Api {
    axiosClient: Axios;

    constructor() {
        this.axiosClient = axios.create({
            timeout: 15000,
            headers: {
                Accept: 'application/json',
                'X-CSRF-Token': this.csrfToken,
            }
        })
    }

    get csrfToken() {
        return document.head.querySelector('meta[name="csrf-token"]').getAttribute('content')
    }

    postJSON = (path: string, body = {}) => post(path, { body, responseKind: 'json' });

    postTurbo = (path: string, body = {}) => post(path, { body, responseKind: 'turbo-stream' });

    putTurbo = (path: string, body = {}) => put(path, { body, responseKind: 'turbo-stream' });

    destroyTurbo = (path: string) => destroy(path, { responseKind: 'turbo-stream' });

    getTurbo = (path: string, params = {}) => get(path, { query: params, responseKind: 'turbo-stream' });
}

export const api = new Api()